import css from './product-ui-view.module.css'

import type { ReactNode } from 'react'

export type ProductUIViewCalendarViewProps = {
    children: ReactNode
}

export function ProductUIViewCalendarView({ children }: ProductUIViewCalendarViewProps) {
    return <div className={css.calendarView}>{children}</div>
}
